import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { ActivatedRoute } from '@angular/router';
import { SelectedArea } from 'src/app/shared/area-select.component';
import { take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-camisa-trieur-card-IV',
    templateUrl: './camisa-trieur-card-IV.component.html'
})

export class CamisaTrieurCardIVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;


    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected route: ActivatedRoute, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Observação e Responsável', false);
        if (this.areaSelect === SelectedArea.Comercial) {
            this.formulario = this.formBuilder.group({
                responsavel_lancamento: [null, [Validators.required]],
                responsavel_analise: [null, []],
                observacao: [null, []],
                criado_por: [null, []],
            });

        }

    }


    public async ngOnInit(): Promise<void> {
        Promise.all([
            this.getUser()
        ])
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    private async getUser(): Promise<void> {
        await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
            this.formulario.get('responsavel_lancamento').setValue(response['user-profile']?.displayName ?? 'Administrador');
        }).catch(async error => {
            await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
                this.formulario.get('responsavel_lancamento').setValue(response ?? 'Administrador');
            }).catch(err => {
            });
        });
    }

}

